import { editOnly } from 'routing/constants'
import {
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID,
} from '../constants/siteStatuses'

export function getEditOnlyContext(site) {
  const editOnlySiteStatus =
    site.SiteStatus.id === SITE_STATUS_EDIT_ONLY_ID ||
    site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  return {
    editOnlySite: editOnlySiteStatus ? editOnly : null,
    editOnlySiteStatus,
  }
}
